import withStyles, { StyleRules } from '@material-ui/core/styles/withStyles';
import ListItem from '@material-ui/core/ListItem';

const styles = (theme): StyleRules => ({
  root: {
    padding: '30px 0',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
});

export default withStyles(styles)(ListItem);
